import { render, staticRenderFns } from "./PopupFormLink.vue?vue&type=template&id=7c4325d6"
import script from "./PopupFormLink.vue?vue&type=script&lang=js"
export * from "./PopupFormLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports